import { deepClone } from '@alova/shared'
import { defineStore } from 'pinia'

export interface PlayerTransmitUserInfo {
  id: string
  nickName: string
  avatarUrl: string

}
export interface customerTransmitUserInfo extends PlayerTransmitUserInfo {
  invitationTime?: string
}
// 初始化状态
const playerUserInfoState: PlayerTransmitUserInfo = {
  id: '',
  nickName: '',
  avatarUrl: '',
}
const customerUserInfoState: customerTransmitUserInfo = {
  id: '',
  nickName: '',
  avatarUrl: '',
  invitationTime: '',
}

// 用户信息
export const transmitUserInfoStore = defineStore(
  'transmitUserInfo',
  () => {
    // 陪玩用户信息
    const playerUserInfo = ref<PlayerTransmitUserInfo>(deepClone(playerUserInfoState))

    // 老板用户信息
    const customerUserInfo = ref<customerTransmitUserInfo>(deepClone(customerUserInfoState))

    // 设置陪玩用户信息
    function setPlayerTransmitUserInfo(val: PlayerTransmitUserInfo) {
      playerUserInfo.value = { ...playerUserInfo.value, ...val }
    }

    // 删除陪玩用户信息
    function removePlayerTransmitUserInfo() {
      playerUserInfo.value = deepClone(playerUserInfoState)
    }

    // 设置老板用户信息
    function setCustomerTransmitUserInfo(val: customerTransmitUserInfo) {
      customerUserInfo.value = { ...customerUserInfo.value, ...val }
    }

    // 删除老板用户信息
    function removeCustomerTransmitUserInfo() {
      customerUserInfo.value = deepClone(customerUserInfoState)
    }

    return {
      playerUserInfo,
      setPlayerTransmitUserInfo,
      removePlayerTransmitUserInfo,
      customerUserInfo,
      setCustomerTransmitUserInfo,
      removeCustomerTransmitUserInfo,
    }
  },
)
